// import { configureStore } from '@reduxjs/toolkit';
// import profileReducer from './Reducer/ProfileReducer';

// const store = configureStore({
//   reducer: {
//     profile: profileReducer,
//   },
// });
// export default store;

import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './Reducer/ProfileReducer';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, profileReducer);

const store = configureStore({
  reducer: {
    profile: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
